
import en from './en.json'
import hi from './hi.json'
import tw from './tw.json'

export const lang={
    en,hi,tw
}
